import React from 'react';
import { connect } from 'react-redux';

import { isScrollingDisabled } from '../../ducks/ui.duck';
import { LayoutComposer, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

import css from './ImprintPage.module.css';

const layoutAreas = `
  topbar
  main
  footer
`;

const ImprintPageComponent = props => {
  const { scrollingDisabled } = props;

  return (
    <Page
      title="Imprint | Avento"
      description="Legal imprint for Avento Gear GmbH, Unterstrasse 6, 9000 St. Gallen, Switzerland."
      scrollingDisabled={scrollingDisabled}
    >
      <LayoutComposer areas={layoutAreas} className={css.layout}>
        {layoutProps => {
          const { Topbar, Main, Footer } = layoutProps;
          return (
            <>
              <Topbar as="header" className={css.topbar}>
                <TopbarContainer currentPage="ImprintPage" />
              </Topbar>

              <Main as="main" className={css.main}>
                <div className={css.content}>
                  <h1 className={css.title}>Imprint</h1>

                  <div className={css.section}>
                    <h2 className={css.label}>Address:</h2>
                    <p className={css.text}>
                      Avento Gear GmbH<br />
                      Unterstrasse 6<br />
                      9000 St. Gallen<br />
                      Switzerland
                    </p>
                  </div>

                  <div className={css.section}>
                    <p className={css.text}>
                      <span className={css.label}>SHAB:</span> 1006490163
                    </p>
                  </div>

                  <div className={css.section}>
                    <p className={css.text}>
                      <span className={css.label}>UID:</span> CHE-185.376.046
                    </p>
                  </div>

                  <div className={css.section}>
                    <h2 className={css.label}>Represented by the Managing Directors:</h2>
                    <p className={css.text}>Lean Stein, Tim Vietze</p>
                  </div>

                  <div className={css.section}>
                    <h2 className={css.label}>Contact:</h2>
                    <p className={css.text}>
                      Customer Service:{' '}
                      <a href="/contact" className={css.link}>
                        https://aventogear.com/contact
                      </a>
                      <br />
                      E-Mail:{' '}
                      <a href="mailto:info@aventogear.com" className={css.link}>
                        info@aventogear.com
                      </a>
                      <br />
                      Phone:{' '}
                      <a href="tel:+41799434499" className={css.link}>
                        +41 79 943 44 99
                      </a>
                    </p>
                  </div>
                </div>
              </Main>

              <Footer>
                <FooterContainer />
              </Footer>
            </>
          );
        }}
      </LayoutComposer>
    </Page>
  );
};

const mapStateToProps = state => ({
  scrollingDisabled: isScrollingDisabled(state),
});

const ImprintPage = connect(mapStateToProps)(ImprintPageComponent);

export default ImprintPage;
